<template>
    <div style="width: 100%;">
        <div v-if="hasRating">
            <div style="background: #eee; width: 100%; border-radius: 3px; overflow:hidden;">
                <div :style="{ background: backgroundColor, width, height: '10px' }"></div>
            </div>
        </div>
        <span v-else>-</span>
    </div>
</template>

<script>
    export default {
        name: "AutotraderResponseCell",
        props: {
            value: {
                type: [Number, String, Object],
                required: true
            }
        },
        computed: {
            hasRating() {
                return this.value.autotrader_metrics
            },
            width() {
                return this.value.autotrader_metrics.performance_score + '%'
            },
            backgroundColor() {
                switch (this.value.autotrader_metrics.performance_rating)
                {
                    case 'LOW':
                        return 'rgb(255, 68, 54)'
                    case 'BELOW_AVERAGE':
                        return 'rgb(255, 196, 0)'
                    case 'ABOVE_AVERAGE':
                        return 'rgb(107, 193, 103)'
                    case 'EXCELLENT':
                        return 'rgb(76, 175, 80)'
                }
            }
        }
    }
</script>

<style scoped>

</style>